import Params from "../options/Params";

import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { Sprite } from "@babylonjs/core/Sprites/sprite";
import { SpriteManager } from "@babylonjs/core/Sprites/spriteManager";

const bubbleImageData = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAABhWlDQ1BJQ0MgcHJvZmlsZQAAKJF9kTtIw1AUhv+mSkUqghYUcchQnSyILxylikWwUNoKrTqY3PQFTRqSFBdHwbXg4GOx6uDirKuDqyAIPkCcHJ0UXaTEc5NCixgPXO7Hf8//c++5gFAvM9XsGAdUzTKSsaiYya6KgVf4EEAfpjEgMVOPpxbT8Kyve+qmuovwLO++P6tHyZkM8InEc0w3LOIN4plNS+e8TxxiRUkhPiceM+iCxI9cl11+41xwWOCZISOdnCcOEYuFNpbbmBUNlXiKOKyoGuULGZcVzluc1XKVNe/JXxjMaSsprtMaRgxLiCMBETKqKKEMCxHaNVJMJOk86uEfcvwJcsnkKoGRYwEVqJAcP/gf/J6tmZ+ccJOCUaDzxbY/RoDALtCo2fb3sW03TgD/M3CltfyVOjD7SXqtpYWPgN5t4OK6pcl7wOUOMPikS4bkSH5aQj4PvJ/RN2WB/luge82dW/Mcpw9Amma1fAMcHAKjBcpe93h3V/vc/u1pzu8HiOJysLzXMIkAAAAGYktHRAAAAAAAAPlDu38AAAAJcEhZcwAACxMAAAsTAQCanBgAAAAHdElNRQfkAQgOEwtFdkd7AAAAGXRFWHRDb21tZW50AENyZWF0ZWQgd2l0aCBHSU1QV4EOFwAAAnNJREFUeNrtm9tygzAMRFciJf3/r20A4z5U7jhGEEwMCVY84yF5YvZoV5iLAeOD9j6B956Uc2nn9cp/T0TnAyCiw2xkEgBOjvEYRbST/07muCcM2qHSLIK/AFwKnGME0AEY9oBBBcVfZLY7RqsXED2AsQQEKiCcpdrXI3pKBKILEXkGBD2Z8fZg4RqIm4DYFAt6wu5toYyjUI/otriBNoi/vrjqS274AeByIFAl4jdDoIrEb4JAlYnPhkAVis+CwJWKh6xNvgGw9z4fwAGruqMgLGrgheqfXXwYLYBmzgVzDri+ySKnxGDRw6sASPW/KhEfR0F1Ac80Pq7w4U+rNcRUaFNR9jUXTJzNSuevUfysPq48+5oL7mLAhqqv6uSEjgUA7QSA2L8xAoDjGHDU/S2IR6qXV9wTmABAxhwwuQo0Bh1g0vqIHG+6CXLaA8yOD4APALkXMqbbpwBGYxD+9X4cIEdn0AGmm6BPI+CMAXB3DiAiF9vCQPUdEfk0AoORPjBoTRD4e5tqAUCvAjASgzv7a1eBrnIIE32sdMex4uoPizdDEoNbpRBuAIbY/upCiIj6CgF4AH0qfmklWJML/JIeFYC4oKvksjgA6LTqP7oX6CtYIvtHhZwFEDVEd3LrD3PVB9Z9KBk+N2tOKP62JH4VgBNCWC1+NYATQcgSnwXgBBCyxWcDiCBc8T5vk3zU7bPEA9u3zIRdYS1e+1gtrO+7R92+KADFDXwwCC8ru35L1YsBeAGIp+y+G4AoFk0Ui1IfXfhohn2DroT4ogBmesQlcQQtnNcrv8NW2n5rxl8CYMYZwHQPcfowJhxDxt0eoj8jGr+WthyJNBE2TAAAAABJRU5ErkJggg==";

export default class BackgroundController {
	constructor(scene) {
		this.scene = scene;
		this.context = null;
		this.time = 0;
		this.bubbles = [];
	}

	init() {
		if (Params.theme == "paper") return;

		this.manager = new SpriteManager("bubbleManager", bubbleImageData, 2000, 64, this.scene);

		const backgroundCanvas = document.getElementById('background');
		if (backgroundCanvas) {
			this.context = backgroundCanvas.getContext('2d');
			for (var x = 0; x <= 32; x++) {
				for (var y = 0; y <= 32; y++) {
					const rgb = Math.floor(192 + 20 * Math.cos((x * x - y * y) / 300));

					this.context.fillStyle = "rgb(" + rgb + "," + rgb + "," + rgb + ")";
					this.context.fillRect(x, y, 1, 1);
				}
			}
		}

		for (let i = 0; i < 100; i++) {
			const sprite = new Sprite("sprite", this.manager);
			sprite.position = this.getRandomPoint();
			sprite.size = Math.random() * 2 + 0.6;
			sprite.offset = Math.random() * 2 - 1;
			sprite.radius = Math.random() * 1 + 1;
			sprite.speed = Math.random() * 1 - 0.5;
			sprite.startingPosition = sprite.position.clone();
			this.bubbles.push(sprite);
		}
	}

	getRandomPoint() {
		const center = new Vector3(0, 0, 0);

		// make 100 attempts before giving up
		for (let i = 0; i < 100; i++) {
			const x = Math.random() * 40 - 20;
			const y = Math.random() * 40 - 20;
			const z = Math.random() * 40 - 20;
			const point = new Vector3(x, y, z);

			if (Vector3.Distance(center, point) > 12) {
				return point;
			}
		}

		return center;
	}

	update(deltaTime) {
		if (!this.context) return;

		// if deltaTime is too high then there was a time skip so don't include the jump
		if (deltaTime > 0.04) return;

		this.time += deltaTime;

		for (var x = 0; x <= 32; x++) {
			for (var y = 0; y <= 32; y++) {
				const rgb = Math.floor(192 + 20 * Math.cos((x * x - y * y) / 300 + this.time));

				this.context.fillStyle = "rgb(" + rgb + "," + rgb + "," + rgb + ")";
				this.context.fillRect(x, y, 1, 1);
			}
		}

		for (let i = 0; i < this.bubbles.length; i++) {
			const bubble = this.bubbles[i];
			const x = bubble.startingPosition.x + Math.sin(this.time * bubble.speed + bubble.offset) * bubble.radius;
			const y = bubble.startingPosition.y + Math.cos(this.time * bubble.speed + bubble.offset) * bubble.radius;
			const z = bubble.startingPosition.z + Math.sin(this.time * bubble.speed + bubble.offset) * bubble.radius;
			bubble.position = new Vector3(x, y, z);
		}
	}
}